import { useState, useEffect } from "react"
import AnimatedText from '../../AnimatedText'
import CustomLoader from '../../common/loader/CustomLoader'
import { getAboutUs } from "../../api/api"
import './OverviewMainSection.css';
import OverviewPic from '../../Assets/overview.jpg'

export default function OverviewMainSection() {
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [aboutUs, setAboutUs] = useState(null);
    
    useEffect(() => {
        fetchAboutUs();
    }, []);
    
    const fetchAboutUs = async () => {
        const payload = {};
        try {
            setLoading(true);
            const res = await getAboutUs(payload);
            const apiData = res?.data?.data;
            
            if (apiData && apiData.PageContent) {
                setAboutUs(apiData);
                setMessage("");
            } else {
                setAboutUs(null);
                setMessage("No data found");
            }
        } catch (error) {
            console.error("Error fetching about us data:", error);
            setMessage("Error loading data");
        } finally {
            setLoading(false);
        }
    };
    
    console.log("aboutUs====>", aboutUs);
    
    return (
        <div className="OverviewMainContainer">
            <div className="ourPackageUpperSection">
                <AnimatedText
                    tag="h2"
                    type="words"
                    y={30}
                    className="rb-title ourpackageTitle"
                >
                    Overviews
                </AnimatedText>
            </div>
            
            {loading ? (
                <CustomLoader/>
            ) : message ? (
                <div className="messageContainer">
                    <p>{message}</p>
                </div>
            ) : aboutUs ? (
                <div className="overviewContentWrapper">
                    <div className="overviewCard">
                        <div className="overviewImageSection">
                            <img 
                                src={OverviewPic} 
                                alt="RB Diagnostic Laboratory" 
                                className="overviewImage"
                            />
                        </div>
                        <div className="overviewTextSection">
                            <div 
                                className="overviewContent"
                                dangerouslySetInnerHTML={{ __html: aboutUs.PageContent }}
                            />
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    )
}